export const DEFAULT_CONTRACT_REVISION_GENERATED_CONDITIONS = [
  'Formato digital/notarial conforme a lo indicado por riesgo.',
  'Datos del cliente correctos en el título, encabezado y firma.',
  'Datos de contacto del cliente correctos en la cláusula 12.',
  'Aval en la cláusula 16 o 17 correspondiente al indicado por riesgo.',
  'Datos del aval correctos en la cláusula 16° o 17°.',
  'Cláusula del estado civil correcta en el número 16.8 o 17.8.',
];

export const BCH_CONTRACT_REVISION_GENERATED_CONDITIONS = [
  'Datos del cliente correctos en el título, encabezado y firma.',
  'Aval correspondiente al indicado en MAFI.',
  'Datos del aval correctos.',
  'Cláusula del estado civil del aval correcta.',
];
